class CanvasLabelLinker {
    link(label) {
        throw new Error("Method .link is not implemented");
    }

    unlink(label) {
        throw new Error("Method .unlink is not implemented");
    }
}

export default CanvasLabelLinker;
